import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: "100px 150px",
    mobile: {
      desktop: {
        padding: "100px 150px",
      },
      smartphone: {
        padding: 15,
      },
    },
  },
  HEADLINE: {
    fontFamily: theme.fontFamily,
    fontSize: "32pt",
    // fontWeight: "bold" as "bold",
    textAlign: "left",
    padding: "20px 0",
    mobile: {
      desktop: {
        fontSize: "32pt",
      },
      smartphone: {
        fontSize: "22pt",
      },
    },
  },
  TEXT: {
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    textAlign: "left",
    lineHeight: "18pt",
    paddingBottom: 40,
    paddingTop: 20,
  },
  LIST: { paddingLeft: 0 },
  LI: {
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    textAlign: "left",
    lineHeight: "18pt",
    padding: "10px 0",
  },
};
